// Homepage editorial selection. Facts here mirror fields that already exist on the
// country records in Places.js - nothing is invented. When the destination data is
// extracted into a shared module, these should read from it instead of repeating it.

export const chapters = [
  {
    id: 'vietnam',
    number: '01',
    country: 'Vietnam',
    title: 'Limestone, water and motorbikes',
    blurb:
      'Ha Long Bay at dawn from the deck of a junk boat, then north to the mountain passes. The two halves of Vietnam that most itineraries never connect.',
    image: 'https://images.unsplash.com/photo-1528127269322-539801943592?w=1900&q=80',
    facts: [
      { label: 'Region', value: 'Southeast Asia' },
      { label: 'Best months', value: 'Sep – Nov' },
      { label: 'Currency', value: 'VND' },
      { label: 'Visa', value: 'E-visa' },
    ],
  },
  {
    id: 'indonesia',
    number: '02',
    country: 'Indonesia',
    title: 'North of the crowds',
    blurb:
      'Everyone lands in Canggu and stays there. We drove three hours north and found the Bali people describe but rarely actually visit.',
    image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=1900&q=80',
    facts: [
      { label: 'Region', value: 'Southeast Asia' },
      { label: 'Best months', value: 'Apr – Oct' },
      { label: 'Currency', value: 'IDR' },
      { label: 'Visa', value: 'On arrival' },
    ],
  },
  {
    id: 'sri-lanka',
    number: '03',
    country: 'Sri Lanka',
    title: 'The train through tea country',
    blurb:
      'Seven hours from Kandy to Ella with the doors open and your feet over the edge. Still the best money we have spent on any journey anywhere.',
    image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=1900&q=80',
    facts: [
      { label: 'Region', value: 'South Asia' },
      { label: 'Best months', value: 'Dec – Mar' },
      { label: 'Currency', value: 'LKR' },
      { label: 'Visa', value: 'ETA online' },
    ],
  },
];

export const atlas = [
  { id: 'dubai', name: 'Dubai, UAE', region: 'Middle East', image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=700&q=80' },
  { id: 'thailand', name: 'Thailand', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1504194104404-433180773017?w=700&q=80' },
  { id: 'vietnam', name: 'Vietnam', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1528127269322-539801943592?w=700&q=80' },
  { id: 'sri-lanka', name: 'Sri Lanka', region: 'South Asia', image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=700&q=80' },
  { id: 'indonesia', name: 'Indonesia', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1537996194471-e657df975ab4?w=700&q=80' },
  { id: 'malaysia', name: 'Malaysia', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1506012787146-f92b2d7d6d96?w=700&q=80' },
  { id: 'singapore', name: 'Singapore', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1525625293386-3f8f99389edd?w=700&q=80' },
  { id: 'cambodia', name: 'Cambodia', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?w=700&q=80' },
  { id: 'philippines', name: 'Philippines', region: 'Southeast Asia', image: 'https://images.unsplash.com/photo-1518509562904-e7ef99cdcc86?w=700&q=80' },
];

export const heroImage =
  'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1900&q=80';
